import React from 'react';
import PropTypes from 'prop-types';
import { testAttributes } from './Constants';
import * as styles from './AccountsList.module.scss';
import AccountListItem from './AccountListItem';

const AccountsList = ({ accounts, className }) => (
    <div
        className={`${styles.accountsListContainer} ${className || ''}`}
        data-testid={testAttributes.ACCOUNTS_LIST_CONTAINER}
    >
        {accounts.map(({ icon, id, title, subTitle, ...props }) => (
            <AccountListItem
                key={id}
                icon={icon}
                title={title}
                subTitle={subTitle}
                {...props}
            />
        ))}
    </div>
);

AccountsList.propTypes = {
    /** accounts: Array of the available accounts */
    accounts: PropTypes.arrayOf(PropTypes.object).isRequired,
    /** className: CSS class of the container */
    className: PropTypes.string,
};

export default AccountsList;
